(() => {
  'use strict';

  const TIME_ZONE = 'America/Santiago';
  const CUTOFF_HOUR = 15;
  const CUTOFF_MINUTE = 0;

  function chileDateTimeParts(date = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);

    return Object.fromEntries(parts.map((part) => [part.type, part.value]));
  }

  function dateFromChileParts(parts, dayOffset = 0) {
    return new Date(Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day) + dayOffset,
      12,
      0,
      0
    ));
  }

  function isBeforeOrAtCutoff(parts) {
    const hour = Number(parts.hour);
    const minute = Number(parts.minute);

    return hour < CUTOFF_HOUR || (hour === CUTOFF_HOUR && minute <= CUTOFF_MINUTE);
  }

  function formatDeliveryDate(date) {
    return new Intl.DateTimeFormat('es-CL', {
      timeZone: TIME_ZONE,
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    }).format(date);
  }

  function currentDeliveryMessage() {
    const chileNow = chileDateTimeParts();
    const arrivesToday = isBeforeOrAtCutoff(chileNow);
    const deliveryDate = dateFromChileParts(chileNow, arrivesToday ? 0 : 1);
    const formattedDate = formatDeliveryDate(deliveryDate);

    if (arrivesToday) {
      return `Recíbelo hoy (${formattedDate}) en comunas con cobertura de la Región Metropolitana.`;
    }

    return `Recíbelo mañana (${formattedDate}) en comunas con cobertura de la Región Metropolitana.`;
  }

  function updateDeliveryEstimates(root = document) {
    const message = currentDeliveryMessage();

    root.querySelectorAll('[data-delivery-rm]').forEach((node) => {
      if (node.textContent !== message) {
        node.textContent = message;
      }
    });
  }

  function initializeDeliveryEstimate() {
    updateDeliveryEstimates();

    // Actualiza el mensaje si el visitante mantiene la página abierta al pasar la hora de corte.
    window.setInterval(() => updateDeliveryEstimates(), 60 * 1000);

    const observer = new MutationObserver(() => updateDeliveryEstimates());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDeliveryEstimate, { once: true });
  } else {
    initializeDeliveryEstimate();
  }

  document.addEventListener('shopify:section:load', (event) => updateDeliveryEstimates(event.target));
  document.addEventListener('cart:updated', () => updateDeliveryEstimates());
})();
